<template>
  <div class="combobox-rental-intake-item-display">
    <div class="flow-row flex items-center">
      <ComboboxRentalIntakeItemInfo :rental-intake-item="item" class="grow" />
      <PBadgeRentalFlowDirection
        v-if="showBadge && flowDirection"
        :flow-direction="flowDirection"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { RentalIntakeItem } from "@/models/rental-intake-item.model"
import { RentalMutationFlowDirections } from "@/enums/rental-mutation-flow-directions"
import PBadgeRentalFlowDirection from "@/components/administration/PBadgeRentalFlowDirection.vue"
import ComboboxRentalIntakeItemInfo from "@/components/administration/combobox-display-templates/basic/ComboboxRentalIntakeItemInfo.vue"

withDefaults(
  defineProps<{
    item: RentalIntakeItem
    flowDirection?: RentalMutationFlowDirections
    showBadge?: boolean
  }>(),
  {
    showBadge: true
  }
)
</script>

<style scoped></style>
